/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)


Vue.filter('formatNumber', (value) => {
    return parseInt(value).toLocaleString()
})

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('report-container', require('./components/report/ReportContainer').default)

Vue.component('dashboard-redemption-monthly', require('./components/report/dashboard-detail/DashboardRedemption').default)
Vue.component('dashboard-delivery-monthly', require('./components/report/dashboard-detail/LineChartDeliveryMonthly').default)

Vue.component('product-edit-dialog', require('./components/product/ProductEditDialog.vue').default);
Vue.component('tracking-filter', require('./components/tracking/TrackingFilter.vue').default);
Vue.component('edit-tracking-no-btn', require('./components/tracking/EditTrackingNoBtn.vue').default);
Vue.component('edit-return-btn', require('./components/tracking/EditReturnBtn.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app'
});

